import script from "./UnsavedChangesDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./UnsavedChangesDialog.vue?vue&type=script&setup=true&lang=ts"

import "./UnsavedChangesDialog.vue?vue&type=style&index=0&id=3f392b9e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f392b9e"]])

export default __exports__